import TournamentMenu from "./TournamentMenu";
import TournamentTable from "./TournamentTable";
import './TournamentsPage.css';
import { Permissions } from '../../context/permissions';
import { useUser } from '../../context/UserContext';

const TournamentsPage = () => {
  const { userProfile } = useUser();
  return (
    <div className='page'>
      <div className='pageHeader'>Torneos</div>
      
      {userProfile?.permissions?.includes(Permissions.MANAGE_TOURNAMENTS) && (
        <div className='pageMenu'>
          <TournamentMenu />
        </div>
      )}
      
      <div>
        <TournamentTable></TournamentTable>
      </div>
    </div>
  );
};

export default TournamentsPage;
